/*
 * Berry Wishlist — client-side store + UI glue (no app, no login, per-device).
 *
 * Single source of truth: localStorage key "berry:wishlist" holding a JSON array
 * of product handles. The product-card hearts, the product-page gallery heart and
 * the wishlist page all read/write through window.WishlistStore. Every mutation
 * dispatches a "wishlist:change" event on document so the UI can react.
 *
 * This file also owns the ONE delegated click listener for every wishlist heart
 * on the page (anything with [data-wishlist-handle]) and keeps count badges
 * ([data-wishlist-count]) in sync, mirroring the cart badge.
 */
(function () {
  var KEY = 'berry:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) { return []; }
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {
      /* private mode / quota exceeded — fail silently */
    }
  }

  function emit() {
    var detail = { items: read() };
    var ev;
    try {
      ev = new CustomEvent('wishlist:change', { detail: detail });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('wishlist:change', false, false, detail);
    }
    document.dispatchEvent(ev);
  }

  var WishlistStore = {
    get: function () { return read(); },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: function (handle) {
      if (!handle) { return; }
      var arr = read();
      if (arr.indexOf(handle) === -1) { arr.push(handle); write(arr); emit(); }
    },
    remove: function (handle) {
      var arr = read();
      var i = arr.indexOf(handle);
      if (i !== -1) { arr.splice(i, 1); write(arr); emit(); }
    },
    toggle: function (handle) {
      if (!handle) { return false; }
      var arr = read();
      var i = arr.indexOf(handle);
      if (i === -1) { arr.push(handle); write(arr); emit(); return true; }
      arr.splice(i, 1); write(arr); emit(); return false;
    },
    count: function () { return read().length; }
  };

  window.WishlistStore = WishlistStore;

  /* ---- one delegated click listener for every heart on the page ---- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-wishlist-handle]') : null;
    if (!btn) { return; }
    event.preventDefault();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (handle) { WishlistStore.toggle(handle); } /* -> emits change -> syncAll */
  });

  /* ---- reflect saved state on every heart + every count badge ---- */
  function syncHearts() {
    var hearts = document.querySelectorAll('[data-wishlist-handle]');
    for (var i = 0; i < hearts.length; i++) {
      var h = hearts[i].getAttribute('data-wishlist-handle');
      hearts[i].setAttribute('aria-pressed', WishlistStore.has(h) ? 'true' : 'false');
    }
  }

  function syncBadges() {
    var n = WishlistStore.count();
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n > 0) { els[i].removeAttribute('hidden'); }
      else { els[i].setAttribute('hidden', ''); }
    }
  }

  function syncAll() { syncHearts(); syncBadges(); }

  document.addEventListener('wishlist:change', syncAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
